"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _appBasicSetup = require("@/api/appBasicSetup");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      ruleForm: {
        agent: '',
        inviteConfig: ''
      },
      rules: {
        agent: [{
          required: true,
          message: '请选择APP模式',
          trigger: 'change'
        }],
        inviteConfig: [{
          required: true,
          message: '请选择邀请码是否填写',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    this.queryAppDetail();
  },
  methods: {
    queryAppDetail: function () {
      var _queryAppDetail2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                // appId
              };
              _context.n = 1;
              return (0, _appBasicSetup.queryAppDetail)(params);
            case 1:
              res = _context.v;
              this.ruleForm.agent = res.data.agent;
              this.ruleForm.inviteConfig = res.data.inviteConfig;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function queryAppDetail() {
        return _queryAppDetail2.apply(this, arguments);
      }
      return queryAppDetail;
    }(),
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认修改此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.appUpdateCommonConfig();
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    appUpdateCommonConfig: function () {
      var _appUpdateCommonConfig2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                agent: this.ruleForm.agent,
                inviteConfig: this.ruleForm.inviteConfig
              };
              _context2.n = 1;
              return (0, _appBasicSetup.appUpdateCommonConfig)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
                this.queryAppDetail();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function appUpdateCommonConfig() {
        return _appUpdateCommonConfig2.apply(this, arguments);
      }
      return appUpdateCommonConfig;
    }()
  }
};